
import { ResellerOrder } from "@/types/resellerOrder";
import { resellerOrders } from "./types";

export const createResellerOrder = async (orderData: Omit<ResellerOrder, 'id' | 'orderNumber' | 'orderDate' | 'status' | 'scheduledActivationTime' | 'waitingPeriod'>): Promise<ResellerOrder> => {
  // Simulate API request delay
  await new Promise(resolve => setTimeout(resolve, 800));
  
  // Generate unique ID and order number
  const id = `order-${Date.now()}`;
  const orderNumber = `RP${Date.now().toString().substring(7)}${Math.floor(100 + Math.random() * 900)}`;
  
  // Create the order
  const newOrder: ResellerOrder = {
    ...orderData,
    id,
    orderNumber,
    orderDate: new Date(),
    status: 'pending',
    // Default to active waiting period with 5-minute activation time
    waitingPeriod: 'active',
    scheduledActivationTime: new Date(Date.now() + 5 * 60 * 1000), // 5 minutes from now
  };
  
  // Add to our mock database
  resellerOrders.push(newOrder);
  
  console.info("New order created:", newOrder);
  
  return newOrder;
};
